import requestApiKey from 'utils/requestApiKey';

const relogApiUrl = 'https://api.relog.kz/api/v3';

export enum GeocodingStatusesEnum {
    GEOCODED = 'GEOCODED',
    NOT_GEOCODED = 'NOT_GEOCODED',
    ALL = 'ALL',
}
export interface RelogContractorLinkDto {
    userId: string;
    accessToken: string;
    contractorLink: string;
    hashedToken: string;
}

export interface RelogResponseDto<T> {
    data: T;
    message?: string;
    status?: string;
}

export async function fetchRelogLink(username: string, apiKey: string): Promise<RelogContractorLinkDto | null> {
    const res = await requestApiKey(`${relogApiUrl}/users/get-link-contractor-by-email/${username}?api-key=${apiKey}`).then(({ data }) => data as RelogResponseDto<RelogContractorLinkDto>);
    return res?.data;
}

export async function fetchGeozoneList(apiKey: string): Promise<string[] | null> {
    const res = await requestApiKey(`${relogApiUrl}/geozone-routes/all?api-key=${apiKey}`).then(({ data }) => data as RelogResponseDto<any[]>);
    const data = res?.data || [];
    if(data.length === 0) return null;
    return data.map((geozone: any) => geozone.name);
}

